interface ContactNameParts {
  lastName?: string;
  firstName?: string;
  middleName?: string;
}

export const formatContactFullName = ({ lastName, firstName, middleName }: ContactNameParts): string =>
  [lastName, firstName, middleName].filter(Boolean).join(' ');
